
import { Fragment } from "react";
const TopBoxDetail = ({ data }) => {

    return (
        <Fragment>
            <div className="border-bottom d-flex py-2 mb-3 bg-white justify-content-between px-3"
                style={{ marginRight: "-10px", marginLeft: "-10px" }} >
                {data.map(item => (
                    <p className="nfs-10 text-center mb-1 d-flex flex-column allCenter">
                        <span className="fw700 mb-1">{item.label}:</span>
                        <span>{item.val}</span>
                    </p>
                ))}
            </div>

        </Fragment >
    )
};

export default TopBoxDetail;
